import React from 'react';
import ReactDOM from 'react-dom';

import ArcGisMap from './app';

Array.from(document.querySelectorAll('.directrelief__arcgis-map'))
  .forEach((element) => {
    ReactDOM.render(
      <ArcGisMap
        attachmentId={element.dataset.attachmentid}
        imgCaption={element.dataset.imgcaption}
        imgUrl={element.dataset.imgurl}
        mapurl={element.dataset.mapurl}
        mapsize={element.dataset.mapsize}
        buttontxt={element.dataset.buttontxt}
        buttonstyle={element.dataset.buttonstyle}
        buttonalign={element.dataset.buttonalign}
      />,
      element,
    );
  });
